// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import TheShelfMainLogo from '../assets/images/TheShelfMainLogo.svg';
import InceptionLogo from '../assets/images/InceptionLogo.svg';

type SvgImport = string | React.ComponentType<React.SVGProps<SVGSVGElement>>;

interface CompanyAssets {
  logo: SvgImport;
  favicon: string;
}

const COMPANY_ASSETS: Record<string, CompanyAssets> = {
  G42: {
    logo: TheShelfMainLogo,
    favicon: '/app/g42-fav.png'
  },
  Inception42: {
    logo: InceptionLogo,
    favicon: '/app/inc-fav.jpg'
  }
};

const DEFAULT_COMPANY = 'G42';

export const getCompanyAssets = (companyName?: string | null): CompanyAssets => {
  if (!companyName) {
    return COMPANY_ASSETS[DEFAULT_COMPANY];
  }

  // Exact match
  if (COMPANY_ASSETS[companyName]) {
    return COMPANY_ASSETS[companyName];
  }

  // Case-insensitive match
  const normalizedName = Object.keys(COMPANY_ASSETS).find((key) => key.toLowerCase() === companyName.toLowerCase());

  if (normalizedName) {
    return COMPANY_ASSETS[normalizedName];
  }

  // Default fallback
  return COMPANY_ASSETS[DEFAULT_COMPANY];
};

export const updateFavicon = (faviconPath: string): void => {
  const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
  if (link) {
    link.href = faviconPath;
  } else {
    const newLink = document.createElement('link');
    newLink.rel = 'icon';
    newLink.href = faviconPath;
    document.head.appendChild(newLink);
  }
};
